"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendUuidToLinks = exports.addQueryParamToUnlayerFormLinkVariable = exports.getUnlayerFormLinkVariables = exports.formatBodyForRecipient = exports.replaceUnlayerFormLinkButton = exports.replaceBodyWithViewTickets = exports.replaceBodyWithETickets = exports.replaceBodyWithPrefilledForms = exports.replaceBodyWithForm = exports.getVariableAttribute = exports.getVariableAttributeRegex = exports.getFormVariables = exports.getBodyVariables = exports.removeVariableInstancesFromBody = exports.getViewTicketsLabel = exports.replaceBodyLinksVariables = exports.replaceBodyLinkVariablesByRegex = exports.replaceBodyWithLastAmount = exports.replaceBodyWithSimplesVariables = exports.sanitizeName = exports.replaceBodyWithToCompleteForms = exports.replaceBodyCustomLinkVariable = exports.replaceBodyLinkVariables = exports.replaceBodyVariables = exports.getVariableRegex = exports.getManyVariableRegex = exports.getLocationVariable = exports.getEndDateVariable = exports.getStartDateVariable = exports.getViewTicketsVariable = exports.getETicketVariable = exports.getPrefilledformVariable = exports.getButtonHtml = exports.getVariableHtml = exports.parseWysiwygCustomVariables = exports.isKnownStaticVariableTag = exports.knownVariables = exports.dynamicVariableTag = void 0;
const luxon_1 = require("luxon");
const uuid_1 = require("uuid");
const wysiwyg_1 = require("../constants/wysiwyg");
const enums_1 = require("../enums");
const wysiwyg_2 = require("../enums/wysiwyg");
const locales_1 = require("../internationalization/enums/locales");
const dates_1 = require("../internationalization/features/dates");
const string_1 = require("./string");
const magicalLink_1 = require("./magicalLink");
exports.dynamicVariableTag = {
    getTag: (key) => `{{${key}}}`,
};
exports.knownVariables = [
    { tag: wysiwyg_2.StaticVariableTag.FirstName, formatKey: wysiwyg_2.StaticVariableFormatKey.FirstName },
    { tag: wysiwyg_2.StaticVariableTag.LastName, formatKey: wysiwyg_2.StaticVariableFormatKey.LastName },
    { tag: wysiwyg_2.StaticVariableTag.LastAmount, formatKey: wysiwyg_2.StaticVariableFormatKey.LastAmount },
];
const isKnownStaticVariableTag = (tag) => exports.knownVariables.some((variable) => variable.tag === tag);
exports.isKnownStaticVariableTag = isKnownStaticVariableTag;
const parseWysiwygCustomVariables = (wysiwygVariables) => {
    return {
        linkVariables: Object.values(wysiwygVariables?.linkVariables || {}),
    };
};
exports.parseWysiwygCustomVariables = parseWysiwygCustomVariables;
const getVariableHtml = ({ text, tag, extraProps, interactive, }) => `<span class="fr-deletable styled-tag-chip"${interactive ? ' style="cursor: pointer;"' : ""} contenteditable="false" ${wysiwyg_1.VARIABLE_DATA_ATTR}="${tag}"${extraProps ? " " + extraProps : ""}>${text}</span>`;
exports.getVariableHtml = getVariableHtml;
const getButtonHtml = ({ text, tag, interactive }) => `<span class="fr-deletable styled-tag-button"${interactive ? ' style="cursor: pointer;"' : ""} contenteditable="false" ${wysiwyg_1.VARIABLE_DATA_ATTR}="${tag}" >${text}</span>`;
exports.getButtonHtml = getButtonHtml;
const getPrefilledformVariable = (text, tag, { formId, formType }) => {
    const formIdVariable = `${wysiwyg_1.PREFILLED_FORM_ID}="${exports.dynamicVariableTag.getTag(formId)}"`;
    const formTypeVariable = `${wysiwyg_1.PREFILLED_FORM_TYPE}="${exports.dynamicVariableTag.getTag(formType)}"`;
    const cursorPointerStyle = 'style="cursor: pointer;"';
    return (0, exports.getVariableHtml)({
        text,
        tag,
        extraProps: `${formIdVariable} ${formTypeVariable} ${cursorPointerStyle}`,
        interactive: true,
    });
};
exports.getPrefilledformVariable = getPrefilledformVariable;
const getETicketVariable = (text) => {
    const tag = exports.dynamicVariableTag.getTag(`${wysiwyg_1.E_TICKET_KEY}${(0, uuid_1.v4)()}`);
    return (0, exports.getVariableHtml)({ text, tag });
};
exports.getETicketVariable = getETicketVariable;
const getViewTicketsVariable = (text) => {
    const tag = exports.dynamicVariableTag.getTag(`${wysiwyg_1.VIEW_TICKETS_KEY}-${(0, uuid_1.v4)()}`);
    return (0, exports.getVariableHtml)({ text, tag });
};
exports.getViewTicketsVariable = getViewTicketsVariable;
const getStartDateVariable = (text, extraProps) => {
    const tag = exports.dynamicVariableTag.getTag(`${wysiwyg_1.DATE_KEY}-${(0, uuid_1.v4)()}`);
    return (0, exports.getVariableHtml)({ text, tag, extraProps });
};
exports.getStartDateVariable = getStartDateVariable;
const getEndDateVariable = (text, extraProps) => {
    const tag = exports.dynamicVariableTag.getTag(`${wysiwyg_1.END_DATE_KEY}-${(0, uuid_1.v4)()}`);
    return (0, exports.getVariableHtml)({ text, tag, extraProps });
};
exports.getEndDateVariable = getEndDateVariable;
const getLocationVariable = (text, extraProps) => {
    const tag = exports.dynamicVariableTag.getTag(`${wysiwyg_1.LOCATION_KEY}-${(0, uuid_1.v4)()}`);
    return (0, exports.getVariableHtml)({ text, tag, extraProps });
};
exports.getLocationVariable = getLocationVariable;
const getManyVariableRegex = (keys) => {
    return keys.map((key) => (0, exports.getVariableRegex)(key)).join("|");
};
exports.getManyVariableRegex = getManyVariableRegex;
const getVariableRegex = (key) => `<span[^>]*${wysiwyg_1.VARIABLE_DATA_ATTR}="{{${key}.*?}}"(?:[^>]*fr-original-style="([^"]*)")?[^>]*>(.*?)</span>`;
exports.getVariableRegex = getVariableRegex;
const replaceBodyVariables = (body, variable, value) => {
    const regex = (0, exports.getVariableRegex)(variable);
    return body.replace(new RegExp(regex, "g"), (_, originalStyle = "") => {
        return originalStyle ? `<span style="${originalStyle}">${value}</span>` : value;
    });
};
exports.replaceBodyVariables = replaceBodyVariables;
const replaceNameVariable = (body, variable, value) => {
    const emptyChipWithComma = `<span[^>]*${wysiwyg_1.VARIABLE_DATA_ATTR}="{{${variable}[^}"]*}}"[^>]*>[^<]*</span>,`;
    const cleaned = value ? body : body.replace(new RegExp(emptyChipWithComma, "g"), "");
    return (0, exports.replaceBodyVariables)(cleaned, variable, value);
};
const getAnchor = (label, link, index) => 
// style box-sizing is added to make sure the variable has the same behavior style as using react
`<a href="${link}" rel="noopener noreferrer" target="_blank" style="box-sizing: border-box">${label}${index || ""}</a>`;
const replaceBodyLinkVariables = (body, link, variable) => {
    // For button we keep the entire variable to keep design
    const isButtonVariable = variable.includes(wysiwyg_1.FORM_LINK_BUTTON_KEY) || variable.includes(wysiwyg_1.CUSTOM_LINK_KEY);
    return body.replace(variable, (value) => {
        const label = value.split(">")[1].split("<")[0];
        return getAnchor(isButtonVariable ? value : label, link);
    });
};
exports.replaceBodyLinkVariables = replaceBodyLinkVariables;
const replaceBodyCustomLinkVariable = (body) => {
    const htmlVariables = (0, exports.getBodyVariables)(body, [wysiwyg_1.CUSTOM_LINK_KEY]);
    if (!htmlVariables) {
        return body;
    }
    for (const htmlVariable of htmlVariables) {
        const link = (0, exports.getVariableAttribute)(htmlVariable, wysiwyg_1.CUSTOM_LINK);
        if (link) {
            body = (0, exports.replaceBodyLinkVariables)(body, link, htmlVariable);
        }
    }
    return body;
};
exports.replaceBodyCustomLinkVariable = replaceBodyCustomLinkVariable;
const replaceBodyWithToCompleteForms = (frontendUrl, recipient, body, toCompleteForm) => {
    body = (0, exports.replaceBodyWithForm)(frontendUrl, body, { regexKey: wysiwyg_1.MAGICAL_LINK_KEY }, toCompleteForm, recipient);
    return body;
};
exports.replaceBodyWithToCompleteForms = replaceBodyWithToCompleteForms;
// Placeholder / junk name values (imported contacts, serialized null/undefined) that should render as an
// empty name rather than literal "null", "N A", etc.
const EMPTY_NAME_PLACEHOLDERS = ["n a", "n/a", "null", "undefined"];
const sanitizeName = (name) => {
    if (!name) {
        return "";
    }
    const normalized = name.trim().toLowerCase();
    if (!normalized || EMPTY_NAME_PLACEHOLDERS.includes(normalized)) {
        return "";
    }
    return name;
};
exports.sanitizeName = sanitizeName;
const replaceBodyWithSimplesVariables = (defaultBody, recipient) => {
    const { firstName, lastName } = recipient;
    let body = replaceNameVariable(defaultBody, "firstname", (0, exports.sanitizeName)(firstName));
    body = replaceNameVariable(body, "lastname", (0, exports.sanitizeName)(lastName));
    return body;
};
exports.replaceBodyWithSimplesVariables = replaceBodyWithSimplesVariables;
const replaceBodyWithLastAmount = (body, lastAmountFormatted) => {
    return (0, exports.replaceBodyVariables)(body, "last_amount", lastAmountFormatted ?? "");
};
exports.replaceBodyWithLastAmount = replaceBodyWithLastAmount;
const replaceBodyLinkVariablesByRegex = (body, link, key) => {
    const regex = new RegExp((0, exports.getVariableRegex)(key), "g");
    return body.replace(regex, (value) => {
        const label = value.split(">")[1].split("<")[0];
        return getAnchor(label, link);
    });
};
exports.replaceBodyLinkVariablesByRegex = replaceBodyLinkVariablesByRegex;
const replaceBodyLinksVariables = (body, links, variable, labelOverride) => {
    return body.replace(variable, (value) => {
        const label = labelOverride ?? value.split(">")[1].split("<")[0];
        return links.reduce((prev, current, index) => {
            const separator = index === 0 ? "" : " ";
            return prev + separator + getAnchor(label, current, index);
        }, "");
    });
};
exports.replaceBodyLinksVariables = replaceBodyLinksVariables;
const getViewTicketsLabel = (locale, ticketCount) => {
    const isSingular = ticketCount === 1;
    // eslint-disable-next-line zeffy-linter/no-locale-condition
    if (locale === locales_1.Locales.FR) {
        return isSingular ? "Voir le billet" : "Voir les billets";
    }
    // eslint-disable-next-line zeffy-linter/no-locale-condition
    if (locale === locales_1.Locales.ES) {
        return isSingular ? "Ver la entrada" : "Ver las entradas";
    }
    return isSingular ? "View ticket" : "View tickets";
};
exports.getViewTicketsLabel = getViewTicketsLabel;
const removeVariableInstancesFromBody = (body, variable) => {
    return body.replace(variable, () => {
        return "";
    });
};
exports.removeVariableInstancesFromBody = removeVariableInstancesFromBody;
const getBodyVariables = (body, keys) => {
    const regex = new RegExp((0, exports.getManyVariableRegex)(keys), "g");
    return body.match(regex);
};
exports.getBodyVariables = getBodyVariables;
const getFormVariables = async ({ body, variableKeys, }) => {
    const htmlVariables = (0, exports.getBodyVariables)(body, variableKeys);
    return htmlVariables?.map((variable) => {
        const key = (0, exports.getVariableAttribute)(variable, wysiwyg_1.VARIABLE_DATA_ATTR);
        const formId = (0, exports.getVariableAttribute)(variable, wysiwyg_1.PREFILLED_FORM_ID);
        const formType = (0, exports.getVariableAttribute)(variable, wysiwyg_1.PREFILLED_FORM_TYPE);
        const text = (0, exports.getVariableAttribute)(variable, wysiwyg_1.VARIABLE_TEXT);
        const link = (0, exports.getVariableAttribute)(variable, wysiwyg_1.CUSTOM_LINK);
        const buttonColor = (0, exports.getVariableAttribute)(variable, wysiwyg_1.BUTTON_COLOR);
        return { key, formId, formType, text, link, buttonColor };
    });
};
exports.getFormVariables = getFormVariables;
const getVariableAttributeRegex = (parameter) => `${parameter}="{{.*?}}"`;
exports.getVariableAttributeRegex = getVariableAttributeRegex;
const getVariableAttribute = (variable, parameter) => {
    const regex = new RegExp((0, exports.getVariableAttributeRegex)(parameter), "g");
    const attribute = variable.match(regex)?.[0];
    return attribute?.split(`{{`)?.[1]?.split("}}")?.[0];
};
exports.getVariableAttribute = getVariableAttribute;
const replaceBodyWithForm = (frontendUrl, body, params, formObject, recipient) => {
    if (!formObject.form.path) {
        return body;
    }
    const { type, form } = formObject;
    if (type === enums_1.FormType.DonationForm) {
        const magicalLink = (0, magicalLink_1.getDonationFormMagicalLink)(frontendUrl, recipient, form);
        if (params.regexKey) {
            return (0, exports.replaceBodyLinkVariablesByRegex)(body, magicalLink, params.regexKey);
        }
        else if (params.htmlVariable) {
            return (0, exports.replaceBodyLinkVariables)(body, magicalLink, params.htmlVariable);
        }
        return body;
    }
    else {
        const magicalLink = (0, magicalLink_1.getTicketingMagicalLink)(frontendUrl, recipient, form.path);
        if (params.regexKey) {
            return (0, exports.replaceBodyLinkVariablesByRegex)(body, magicalLink, params.regexKey);
        }
        else if (params.htmlVariable) {
            return (0, exports.replaceBodyLinkVariables)(body, magicalLink, params.htmlVariable);
        }
        return body;
    }
};
exports.replaceBodyWithForm = replaceBodyWithForm;
const replaceBodyWithPrefilledForms = (frontendUrl, recipient, body, forms) => {
    const htmlVariables = (0, exports.getBodyVariables)(body, [wysiwyg_1.PREFILLED_FORM_KEY, wysiwyg_1.FORM_LINK_BUTTON_KEY]);
    if (forms.donationForms || forms.ticketings) {
        (htmlVariables || []).map((htmlVariable) => {
            const formId = (0, exports.getVariableAttribute)(htmlVariable, wysiwyg_1.PREFILLED_FORM_ID);
            const formType = (0, exports.getVariableAttribute)(htmlVariable, wysiwyg_1.PREFILLED_FORM_TYPE);
            if (formType && formId) {
                const form = formType === enums_1.FormType.DonationForm ? forms.donationForms[formId] : forms.ticketings[formId];
                if (!form) {
                    return body;
                }
                body = (0, exports.replaceBodyWithForm)(frontendUrl, body, { htmlVariable }, { form, type: formType }, recipient);
            }
        });
    }
    return body;
};
exports.replaceBodyWithPrefilledForms = replaceBodyWithPrefilledForms;
const replaceBodyWithETickets = (eTicketUrls, body, ticketingId) => {
    const htmlVariables = (0, exports.getBodyVariables)(body, [wysiwyg_1.E_TICKET_KEY]);
    (htmlVariables || []).map((htmlVariable) => {
        if (eTicketUrls && ticketingId) {
            body = (0, exports.replaceBodyLinksVariables)(body, eTicketUrls, htmlVariable);
        }
        else {
            body = (0, exports.removeVariableInstancesFromBody)(body, htmlVariable);
        }
    });
    return body;
};
exports.replaceBodyWithETickets = replaceBodyWithETickets;
const replaceBodyWithViewTickets = (viewTicketsUrls, body, ticketingId, labelOverride) => {
    const htmlVariables = (0, exports.getBodyVariables)(body, [wysiwyg_1.VIEW_TICKETS_KEY]);
    (htmlVariables || []).map((htmlVariable) => {
        if (viewTicketsUrls?.length && ticketingId) {
            body = (0, exports.replaceBodyLinksVariables)(body, viewTicketsUrls, htmlVariable, labelOverride);
        }
        else {
            body = (0, exports.removeVariableInstancesFromBody)(body, htmlVariable);
        }
    });
    return body;
};
exports.replaceBodyWithViewTickets = replaceBodyWithViewTickets;
/**
 * Replace Unlayer form link button placeholders with personalized form links
 * Pattern: {{unlayer-form-link-button-FormType_formId}} with optional query parameters
 */
const replaceUnlayerFormLinkButton = (frontendUrl, recipient, body, prefilledForms) => {
    // Pattern to match: {{unlayer-form-link-button-FormType_formId}} with optional query parameters
    const regex = /{{unlayer-form-link-button-(DonationForm|Ticketing)-([a-zA-Z0-9-]+)(\?[^}]*)?}}/g;
    return body.replace(regex, (match, formType, formId, queryParams) => {
        // Find the form in the prefilled forms
        const form = formType === enums_1.FormType.DonationForm ? prefilledForms.donationForms?.[formId] : prefilledForms.ticketings?.[formId];
        if (!form) {
            return match; // If form not found, leave the placeholder as is
        }
        // Generate base magical link
        const baseLink = formType === enums_1.FormType.DonationForm
            ? (0, magicalLink_1.getDonationFormMagicalLink)(frontendUrl, recipient, form)
            : (0, magicalLink_1.getTicketingMagicalLink)(frontendUrl, recipient, form.path);
        // Append query parameters if they exist
        if (queryParams) {
            const params = queryParams.substring(1); // Remove the '?' prefix
            const separator = baseLink.includes("?") ? "&" : "?";
            return `${baseLink}${separator}${params}`;
        }
        return baseLink;
    });
};
exports.replaceUnlayerFormLinkButton = replaceUnlayerFormLinkButton;
const formatBodyForRecipient = ({ frontendUrl, recipient, body: defaultBody, variables, locale, }) => {
    let body = defaultBody; // Using let allow to be more clear on the mutation cascade of the body
    body = (0, exports.replaceBodyWithSimplesVariables)(body, recipient);
    body = (0, exports.replaceBodyCustomLinkVariable)(body);
    if (!variables) {
        return body;
    }
    const { toCompleteForms, prefilledForms, ticketingForm } = variables;
    const toCompleteForm = toCompleteForms?.[recipient.contactId || recipient.id]; // use contact id if available, otherwise use user id
    const recipientCommandDetails = ticketingForm?.recipientsWithCommandDetailsMap?.[recipient.contactId || recipient.id]; // use contact id if available, otherwise use user id
    if (prefilledForms) {
        body = (0, exports.replaceBodyWithPrefilledForms)(frontendUrl, recipient, body, prefilledForms);
        // Add the Unlayer form link button replacement
        body = (0, exports.replaceUnlayerFormLinkButton)(frontendUrl, recipient, body, prefilledForms);
    }
    if (toCompleteForm) {
        body = (0, exports.replaceBodyWithToCompleteForms)(frontendUrl, recipient, body, toCompleteForm);
    }
    body = (0, exports.replaceBodyWithETickets)(recipientCommandDetails?.eTicketUrls, body, ticketingForm?.id);
    if (recipientCommandDetails?.viewTicketsUrls) {
        const ticketCount = recipientCommandDetails.ticketCount ?? recipientCommandDetails.viewTicketsUrls.length;
        body = (0, exports.replaceBodyWithViewTickets)(recipientCommandDetails.viewTicketsUrls, body, ticketingForm?.id, (0, exports.getViewTicketsLabel)(locale, ticketCount));
    }
    const locationValue = ticketingForm?.location?.trim() || "N/A";
    body = (0, exports.replaceBodyVariables)(body, wysiwyg_1.LOCATION_KEY, locationValue);
    if (recipientCommandDetails?.startUtc) {
        body = (0, exports.replaceBodyVariables)(body, wysiwyg_1.DATE_KEY, (0, dates_1.formatDateTimeToLocaleString)(recipientCommandDetails?.startUtc, locale, luxon_1.DateTime.DATETIME_FULL, ticketingForm?.timeZone));
    }
    if (recipientCommandDetails?.endUtc) {
        body = (0, exports.replaceBodyVariables)(body, wysiwyg_1.END_DATE_KEY, (0, dates_1.formatDateTimeToLocaleString)(recipientCommandDetails?.endUtc, locale, luxon_1.DateTime.DATETIME_FULL, ticketingForm?.timeZone));
    }
    return body;
};
exports.formatBodyForRecipient = formatBodyForRecipient;
const getUnlayerFormLinkVariables = (body) => {
    const unlayerButtonRegex = /{{unlayer-form-link-button-(DonationForm|Ticketing)-([a-zA-Z0-9-]+)(\?[^}]*)?}}/g;
    const variables = [];
    let match;
    while ((match = unlayerButtonRegex.exec(body)) !== null) {
        const [, formType, formId, queryParams] = match;
        variables.push({
            formId,
            formType: formType,
            queryParams: queryParams?.substring(1), // Remove the '?' prefix
        });
    }
    return variables;
};
exports.getUnlayerFormLinkVariables = getUnlayerFormLinkVariables;
/**
 * Adds or updates a query parameter in an unlayer form link variable string
 * @param variable The unlayer form link variable string (e.g., "{{unlayer-form-link-button-DonationForm-123?existing=param}}")
 * @param paramName The query parameter name to add/update
 * @param paramValue The query parameter value
 * @returns The updated variable string
 */
const addQueryParamToUnlayerFormLinkVariable = (variable, paramName, paramValue) => {
    // Extract the base pattern and existing query params
    const match = variable.match(/^({{unlayer-form-link-button-[^}]+?)(\?[^}]*)?}}$/);
    if (!match) {
        return variable; // Not a valid unlayer form link variable
    }
    const [, basePattern, existingParams] = match;
    if (!existingParams) {
        // No existing query params, add new one
        return `${basePattern}?${paramName}=${paramValue}}}`;
    }
    // Parse existing query params
    const queryString = existingParams.substring(1); // Remove the '?'
    const params = new URLSearchParams(queryString);
    // Add or update the parameter
    params.set(paramName, paramValue);
    // Reconstruct the variable
    return `${basePattern}?${params.toString()}}}`;
};
exports.addQueryParamToUnlayerFormLinkVariable = addQueryParamToUnlayerFormLinkVariable;
/**
 * Appends or updates a query parameter with a UUID v4 to all links in the body
 * Each link gets a unique UUID
 * Skips any href attributes that contain variables (starting with {{)
 * @param body The email body HTML string
 * @param queryParamName The name of the query parameter to add
 * @returns The updated body with the query parameter added to all links
 */
const appendUuidToLinks = (body, queryParamName) => {
    // Handle regular href links (excluding any variables starting with {{)
    let updatedBody = body.replace(/href="([^"]+)"/g, (match, rawUrl) => {
        // Skip if this is any variable starting with {{
        if (rawUrl.startsWith("{{")) {
            return match;
        }
        const url = (0, string_1.decodeHtmlEntities)(rawUrl);
        if (/^(tel:|mailto:|sms:)/i.test(url)) {
            return match;
        }
        const linkId = (0, uuid_1.v4)(); // Generate unique ID for each link
        try {
            const urlObj = new URL(url);
            urlObj.searchParams.set(queryParamName, linkId);
            return `href="${(0, string_1.escapeHtml)(urlObj.toString())}"`;
        }
        catch {
            // If URL parsing fails (e.g., relative URLs), append manually
            const separator = url.includes("?") ? "&" : "?";
            return `href="${(0, string_1.escapeHtml)(`${url}${separator}${queryParamName}=${linkId}`)}"`;
        }
    });
    // Handle unlayer form link button variables
    updatedBody = updatedBody.replace(/{{unlayer-form-link-button-[^}]+}}/g, (variable) => {
        const linkId = (0, uuid_1.v4)(); // Generate unique ID for each variable
        return (0, exports.addQueryParamToUnlayerFormLinkVariable)(variable, queryParamName, linkId);
    });
    return updatedBody;
};
exports.appendUuidToLinks = appendUuidToLinks;
